import type { TeamsListParams } from '../accounts/api';

export const queryKeys = {
  accounts: {
    all: ['accounts'] as const,
    list: (params?: Record<string, unknown>) => ['accounts', 'list', params ?? {}] as const,
    detail: (accountId: string) => ['accounts', 'detail', accountId] as const,
    subscription: (accountId: string) => ['accounts', 'subscription', accountId] as const,
    subscriptionUsage: (accountId: string) => ['accounts', 'subscription-usage', accountId] as const,
    legacySubscription: (accountId: string) => ['accounts', 'legacy-subscription', accountId] as const,
    memberSessions: (accountId: string) => ['accounts', 'member-sessions', accountId] as const,
    projectsPage: (accountId: string, offset: number) => ['accounts', 'projects', accountId, 'page', offset] as const,
    projectSearch: (accountId: string, term: string) => ['accounts', 'projects', accountId, 'search', term] as const,
    projectsByKeys: (accountId: string, keys: readonly string[]) =>
      ['accounts', 'projects', accountId, 'by-keys', keys] as const,
    projectEnvironments: (accountId: string, projectKey: string) =>
      ['accounts', 'environments', accountId, projectKey] as const,
    customRoles: (accountId: string) => ['accounts', 'custom-roles', accountId] as const,
    teams: (accountId: string, params: TeamsListParams) => ['accounts', 'teams', accountId, params] as const,
    members: (accountId: string, params?: { url?: string; paginated?: boolean }) =>
      ['accounts', 'members', accountId, params ?? {}] as const,
    // Prefix of every members query for an account, regardless of pagination
    // params — use it to invalidate them all at once.
    allMembers: (accountId: string) => ['accounts', 'members', accountId] as const,
    auditLogEntries: (
      accountId: string,
      params: {
        nextUrl?: string;
        query?: string;
        spec?: string;
        member?: string;
        fuzzy?: boolean;
        date?: ReadonlyArray<Date | null>;
        actions?: readonly string[];
        beforeCursor?: number;
      },
    ) => ['accounts', 'audit-entries', accountId, params] as const,
    auditLogEntryDetail: (accountId: string, entryUrl: string) =>
      ['accounts', 'audit-entry-detail', accountId, entryUrl] as const,
  },
  usage: {
    byAccount: (accountId: string, params: { start: string; end: string }) => ['usage', accountId, params] as const,
  },
} as const;
